import { Container, Row, Col } from "react-bootstrap";
import ApeCard from "../../components/apeCard";
import { myCollections, myCollectionOptions } from "../../data";

import { CollectionContainer } from '../alphaCollection/alpha.style';

import leftImg from '../../images/home-left-side.svg';
import rightImg from '../../images/home-right-side.svg'
import Footer from "../../components/footer";
import ApeBtn from "../../components/button";
import SearchElement from "../../components/searchInput";
import OptionSelect from "../../components/selectOption";
import GridOption from "../../components/gridSelect";
import { useState } from "react";
import DisplayApeModal from "../../components/apeDetailModal";

const CollectionPage = () => {
  const [selectedApe, setSelectedApe] = useState(null);

  const cleanupModal = () => {
    setSelectedApe(null);
  }

  const [searchOptions, setSearchOptions] = useState(myCollections);

  const handleSearch = (e) => {
    const search = e.target.value;
    const filtered = myCollections.filter((item) => {
      return item.id.toString().includes(search);
    });
    setSearchOptions(filtered);
  }

  return (
    <>
    <Container className="mt-5 pt-5">
      <CollectionContainer>
        <Row>
            <Col lg={12} xl={6} className="d-flex top-search collection">
              <SearchElement 
                handleChange={handleSearch}
                placeholder="Find an Ape by ID" >
                <ApeBtn title="Search" active />
              </SearchElement>

            </Col>
            <Col lg={12} xl={6} className="d-flex grid-option">
              <OptionSelect options={myCollectionOptions} />
              <GridOption />
            </Col>
        </Row>
        <div className="d-flex justify-content-between align-items-baseline my-5">
        <h2>My Collection</h2>
        <span>(6 results)</span>
        </div>
        <Row>
          { searchOptions.map((item, index) => (
            <Col className='mb-4' sm={12} md={6} lg={4} key={index}>
              <ApeCard 
                handleClick={() => {
                  setSelectedApe(item);
                }}
                image={item.image} 
                name={item.name}
                id={item.id}
                likes={item.likes} />
            </Col>
          ))
          }
          </Row>
      </CollectionContainer>
    </Container>
    {
      selectedApe && 
      <DisplayApeModal
       ape={selectedApe}
       onClose={cleanupModal}
      />
      }
    <Footer leftImg={leftImg} rightImg={rightImg} />
    </>
  );
}

export default CollectionPage;